import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { FormatStrip } from './components/FormatStrip';
import { HookSection } from './components/HookSection';
import { PainSection } from './components/PainSection';
import { RevelationSection } from './components/RevelationSection';
import { FeaturedProduct } from './components/FeaturedProduct';
import { TheoryPractice } from './components/TheoryPractice';
import { BonusesSection } from './components/BonusesSection';
import { SocialProof } from './components/SocialProof';
import { ValueStack } from './components/ValueStack';
import { AfterPurchase } from './components/AfterPurchase';
import { Guarantee } from './components/Guarantee';
import { FaqSection } from './components/FaqSection';
import { FinalCta, PageFooter } from './components/FinalCta';
import { MobileCtaBar } from './components/MobileCtaBar';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-full w-full bg-carbon-900 pb-20 font-sans text-paper sm:pb-0" data-id="element-0" data-mp="3ihv22ef0kliv">
      <UrgencyBar data-id="element-1" data-mp="3mjq27fl7ksv2" />
      <Hero data-id="element-2" data-mp="3mj6hxs835sdv" />
      <FormatStrip data-id="element-3" data-mp="3rc9hqi3ghy2i" />
      <main data-id="element-4" data-mp="3rbzn2h7gv2qh">
        <HookSection data-id="element-5" data-mp="3rdaselgk8ijp" />
        <PainSection data-id="element-6" data-mp="3rcsuzli5vya7" />
        <RevelationSection data-id="element-7" data-mp="3relu8fqg3g86" />
        <FeaturedProduct data-id="element-8" data-mp="6hr7hlrojf6" />
        <TheoryPractice data-id="element-9" data-mp="4n4pyuukj8z" />
        <BonusesSection data-id="element-10" data-mp="56qjqnmbrsa" />
        <SocialProof data-id="element-11" data-mp="2zl3brl12165b" />
        <ValueStack data-id="element-12" data-mp="2zllijblcf2rh" />
        <AfterPurchase data-id="element-13" data-mp="2zmeowbge3q93" />
        <Guarantee data-id="element-14" data-mp="2zmwlj96ys6hj" />
        <FaqSection data-id="element-15" data-mp="33mouhn09senf" />
        <FinalCta data-id="element-16" data-mp="33m5a7zn5de68" />
      </main>
      <PageFooter data-id="element-17" data-mp="33ngfk3w8qtzg" />
      <MobileCtaBar data-id="element-18" data-mp="33mylndx1wrup" />
    </div>;
}